import React from 'react';

interface IItemP {
    title : string;
    content : string;
}

const ItemP : React.FC<IItemP> = ({
    title,
    content
}) => {
    return (
        <p><strong>{title}</strong> {content}</p>
    )
}

export default ItemP;